var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "wrapper", staticStyle: { padding: "0 60px" } },
    [
      (_vm.isSwiperInit && _vm.data != "") || undefined
        ? _c(
            "swiper",
            { attrs: { options: _vm.swiperOption } },
            _vm._l(_vm.data, function(item, key) {
              return _c(
                "swiper-slide",
                { key: key, staticClass: "banner-slide" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "item",
                      on: {
                        click: function($event) {
                          return _vm.goRouter(
                            item.es_tycpfl,
                            item.product_type,
                            item.product_code
                          )
                        }
                      }
                    },
                    [
                      item.htyx_title && item.htyx_title.length > 0
                        ? _c("span", { staticClass: "tipd" }, [
                            _vm._v(_vm._s(item.htyx_title))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("strong", [_vm._v(_vm._s(item.product_name))]),
                      _vm._v(" "),
                      _c("p", { staticClass: "desc" }, [
                        _vm._v(_vm._s(item.show_field_ms))
                      ]),
                      _vm._v(" "),
                      item.es_tycpfl &&
                      item.es_tycpfl == _vm.constants.ES_TYCPFL.OTC &&
                      _vm.checkLogin != true
                        ? _c("span", { staticClass: "value" }, [
                            _vm._v("登录查看产品收益")
                          ])
                        : item.show_field_value != ""
                        ? _c("span", { staticClass: "value value2" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("addunit")(
                                  item.show_field_value,
                                  item.show_field_unit
                                )
                              )
                            )
                          ])
                        : _c("span", { staticClass: "value value2" }, [
                            _vm._v("--")
                          ]),
                      _vm._v(" "),
                      item.es_tycpfl &&
                      item.es_tycpfl == _vm.constants.ES_TYCPFL.OTC &&
                      _vm.checkLogin != true
                        ? _c(
                            "span",
                            {
                              staticClass: "more",
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.goRouter(
                                    item.es_tycpfl,
                                    item.product_type,
                                    item.product_code
                                  )
                                }
                              }
                            },
                            [_vm._v("立即登录>>")]
                          )
                        : _c("span", { staticClass: "more" }, [
                            _vm._v(_vm._s(item.product_desc))
                          ])
                    ]
                  )
                ]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.isSwiperInit && _vm.data != "") || undefined
        ? [
            _c("div", { staticClass: "swiper-button-prev" }),
            _vm._v(" "),
            _c("div", { staticClass: "swiper-button-next" })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isSwiperInit == false
        ? _c("div", { staticClass: "no-data" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      (_vm.isSwiperInit && _vm.data == "") || undefined
        ? _c("div", { staticClass: "no-data" }, [_vm._m(1)])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("数据加载中")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无数据")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-005c5209", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-005c5209","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/newprobanner.vue
// module id = null
// module chunks = 